
<div *ngIf="items$ | async;" class="image-container">
  <div
    *ngFor="let product of (items$ | async); let i = index"
    class="product-card"
    (click)="open(product)"
  >
    <div class="product-image">
      <img
        src="{{product.default_image.image300Url}}"
        alt="{{product.name}}"
      />
    </div>
    <h3>{{product.name}}</h3>
  </div>
</div>
